import {useFormikContext} from 'formik';
import React from 'react';
import {useDispatch} from 'react-redux';
import {BottomSheet} from 'react-spring-bottom-sheet';
import CustomRadio from '../../../../../../components/mazraeKit/customRadio';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';
import {FromikType} from '../../../types';

interface IPriceUnitBottomSheetProps {
  openCommonBottomSheet: boolean;
  setOpenCommonBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  name: string;
  bottomSheetData: Array<{title: string; value: string}>;
  shouldDispatch?: boolean;
}

function PriceUnitBottomSheet({
  openCommonBottomSheet,
  setOpenCommonBottomSheet,
  bottomSheetData,
  name,
  shouldDispatch,
}: IPriceUnitBottomSheetProps) {
  const {setFieldValue, values} = useFormikContext<FromikType>();
  const dispatch = useDispatch();

  return (
    <BottomSheet
      onDismiss={() => setOpenCommonBottomSheet(false)}
      open={openCommonBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col gap-3 px-3 pb-3">
        {bottomSheetData?.map(item => {
          return (
            <CustomRadio
              {...item}
              name={name}
              key={item.value}
              value={item.value}
              title={item.title}
              //@ts-ignore
              checked={item.value === values[name]?.value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue(name, {
                  title: item.title,
                  value: e.target.value,
                });
                shouldDispatch &&
                  // @ts-ignore
                  dispatch(
                    addRegisterAdvertisement({
                      [name]: {
                        title: item.title,
                        value: e.target.value,
                      },
                    }),
                  );
                setOpenCommonBottomSheet(false);
              }}
            />
          );
        })}
      </div>
    </BottomSheet>
  );
}

export default PriceUnitBottomSheet;
